<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :viewBox="viewBox"
  >
    <g data-name="グループ 12811" transform="translate(22376 17349)">
      <rect
        data-name="長方形 4501"
        width="26"
        height="20"
        rx="3"
        transform="translate(-22376 -17349)"
        style="fill: #fff"
      />
      <path
        data-name="パス 4492"
        d="M464.126 253.039a.685.685 0 0 1-.518-.24.739.739 0 0 1 .053-1.018l4.03-3.744-4.03-3.74a.739.739 0 0 1-.053-1.018.681.681 0 0 1 .983-.056l4.609 4.277a.741.741 0 0 1 0 1.074l-4.608 4.281a.686.686 0 0 1-.466.184z"
        transform="translate(-22831.43 -17587.039)"
        :style="{ fill: color }"
      />
      <path
        data-name="パス 5099"
        d="M464.126 253.039a.685.685 0 0 1-.518-.24.739.739 0 0 1 .053-1.018l4.03-3.744-4.03-3.74a.739.739 0 0 1-.053-1.018.681.681 0 0 1 .983-.056l4.609 4.277a.741.741 0 0 1 0 1.074l-4.608 4.281a.686.686 0 0 1-.466.184z"
        transform="translate(-22826.43 -17587.039)"
        :style="{ fill: color }"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'HelpSVG',
  props: {
    width: {
      type: String,
      default: '26px',
    },
    height: {
      type: String,
      default: '20px',
    },
    viewBox: {
      type: String,
      default: '0 0 26 20',
    },
    color: {
      type: String,
      default: '#989898',
    },
  },
};
</script>
